import { useCallback, useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { DataContext } from "../../context/DataProvider";
import { Card, Col } from "react-bootstrap";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import { IconButton } from "@mui/material";
import axios from "axios";
import debounce from "lodash/debounce";
import { FaFacebook, FaLinkedin, FaInstagram, FaYoutube } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid"; // Import UUID for generating unique IDs
import Cookies from "js-cookie";
import "./Sidebar.css";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import axiosMain from "../../axiosMain";

function Sidebar() {
  const {
    tenderGPTData,
    setTenderGPTData,
    setTenderData,
    resultGPTData,
    setResultGPTData,
    setSearch,
    loading,
    setLoading,
    searchType,
    setSearchType,
    newSearch,
    setNewSearch,
    showSideBar,
    setShowShowSideBar,
    history,
    lastSearch,
    setLastSearchData,
    setHistory,
    deleteAllCookies,
    setmaxScore,
    setresmaxScore,
    resmaxScore,
    selectFromHistory,
    setSelectFromHistory,
  } = useContext(DataContext);

  const [search, setSearchData] = useState("");
  const [isClickfav, setIsClickfav] = useState(false);

  const toggleHeart = (id) => {
    const updatedHistory = storedHistory.map(item => {
      if (item.thredId === id) {
        return { ...item, isfav: !item.isfav };
      }
      return item;
    });
    setHistory(updatedHistory.reverse());
    localStorage.setItem(searchType === "Tender" ? "tenderGPTData" : "resultGPTData", JSON.stringify(updatedHistory));
    localStorage.setItem(searchType === "Tender" ? "tenderLocalStorageHistory" : "resultLocalStorageHistory", JSON.stringify(updatedHistory));
  };

  //   const [showSideBar, setShow] = useState(false);
  // const { showSideBar, setShowShowSideBar, resultGPTData, tenderGPTData, searchType } = useContext(DataContext);
  const [sidebarClass, setSidebarClass] = useState("sidebar-hidden");
  const [rescount, setRescount] = useState(0);

  useEffect(() => {
    console.log(searchType, "all search val");
    console.log(tenderGPTData, "all search val");

    if (showSideBar) {
      setSidebarClass("sidebar-visible");
    } else {
      setTimeout(() => {
        setSidebarClass("sidebar-hidden");
      }, 100); // Match this delay with the CSS transition duration
    }
  }, [showSideBar]);

  const debouncedFetchData = useCallback(
    debounce(async (searchId, url, type, keysearch) => {
      try {
        const response = await axiosMain.post(
          url,

          type === "Tender"
            ? localStorage.getItem("logDetails") === null
              ? {
                searchkeyword: keysearch,
                total: 50,
                rescount: 0,
                maxScore: 0,
              }
              : {
                searchkeyword: keysearch,
                tabindex: 1,
                maintabindex: 0,
                page: 0,
                total: 20,
                limit: 0,
                sortby: null,
                search: null,
                direction: null,
                sub_no: 253842,
                profilequery: "undefined",
                index: null,
                query: null,
                term: null,
                tenderrefno: null,
                orgname: null,
                subindustry: null,
                minprice: 0,
                maxprice: 0,
                tenderdatetype: null,
                startdate: null,
                enddate: null,
                location: null,
                subscribetype: "all",
                custid: JSON.parse(localStorage.getItem("logDetails"))
                  .CustomerId,
                custsubno: 0,
                macaddress: "54BEF739D5B0",
                loc_type: "undefined",
                regionname: null,
                countryname: null,
                cityname: null,
                statename: null,
                ownership: null,
                tendertype: null,
                tenderstatus: null,
                tendercompetition: null,
                document: null,
                mfa: null,
                keywordsearch: null,
                productname: null,
                searchword: null,
                tenderhostdate: null,
                tenderclosedate: null,
                tender_typewise: "live",
                exactphrase: null,
                wtenderrefno: null,
                wsubindustry: null,
                wlocation: null,
                wtenderhostdate: null,
                wtenderclosedate: null,
                hdn_status: 0,
                wwordsearch: null,
                gemtender: null,
                rescount: 0,
                globeltype: null,
                orderbytype: null,
                categoryflag: "1",
                tendertypewise: null,
                companysubindustry: null,
                userdetailid: JSON.parse(localStorage.getItem("logDetails"))
                  .UserDetailId,
                sortcolumnname: null,
                sortingby: null,
                archive: null,
                domainname: window.location.origin + "/",
                ForExcell: false,
                seosearchlocation: "search",
                querytype: "null",
                last_categoryflag: null,
                last_rescount: 20,
                fromdata: 0,
                biddingtype: null,
                wordsearch: null,
                wexactphrase: null,
                wkeywordsearch: null,
                wgemtender: null,
                wcountryname: null,
                wstatename: null,
                wcityname: null,
                wcompanysubindustry: null,
                worgname: null,
                wownership: null,
                wtendertype: null,
                wminprice: null,
                wmaxprice: null,
                wproductname: null,
                searchItem: null,
                starttime: null,
                endtime: null,
                ES_Hits: null,
                fromInfo: null,
                isfreetender: "undefined",
                tendervalue_data: null,
                maxScore: 0,
              }
            : {
              searchkeyword: keysearch,
              total: 50,
              rescount: 0,
              maxScore: 0,
            }
        );
        console.log("API Response:", response.data);
        // setSearch(search);
        setSearch(keysearch);
        if (type === "Tender") {
          setTenderData(response.data);
          setTenderGPTData((prevData) => {
            const existingSearchIndex = prevData.findIndex(
              (item) => item.searchId === searchId
            );
            if (existingSearchIndex > -1) {
              const updatedGPTData = [...prevData];
              updatedGPTData[existingSearchIndex] = {
                ...updatedGPTData[existingSearchIndex],
                TenderList: [
                  ...updatedGPTData[existingSearchIndex].TenderList,
                  ...response.data.TenderList,
                ],
              };
              //const tenderListar = tenderGPTData?.filter((item) => item.searchId === searchId);
              const tenderListar = updatedGPTData
                ?.filter((item) => item.searchId === searchId)
                ?.at(0)?.TenderList;
              const highestScoreTender = tenderListar.reduce((max, tender) => {
                return tender.elastic_score > max.elastic_score ? tender : max;
              }, tenderListar[0])?.elastic_score;

              setmaxScore(
                parseFloat(
                  (
                    Math.floor(parseFloat(highestScoreTender) * 100) / 100
                  ).toFixed(2)
                )
              );
              return updatedGPTData;
            } else {
              setmaxScore(0);
              return [
                ...prevData,
                { searchId, keysearch, TenderList: response.data.TenderList },
              ];
            }
          });
        } else if (type === "Result") {
          var reshighestScoreTender = 0;
          setResultGPTData((prevData) => {
            const existingSearchIndex = prevData.findIndex(
              (item) => item.searchId === searchId
            );
            if (existingSearchIndex > -1) {
              const updatedGPTData = [...prevData];
              updatedGPTData[existingSearchIndex] = {
                ...updatedGPTData[existingSearchIndex],
                ResultList: [
                  ...updatedGPTData[existingSearchIndex].ResultList,
                  ...response.data.TenderList,
                ],
              };

              const resfiltertenderdat = updatedGPTData
                ?.filter((item) => item.searchId === searchId)
                ?.at(0)?.ResultList;

              if (resfiltertenderdat?.length > 0) {
                reshighestScoreTender = resfiltertenderdat.reduce(
                  (max, tender) => {
                    return parseFloat(tender.elastic_score) >
                      parseFloat(max.elastic_score)
                      ? tender
                      : max;
                  },
                  resfiltertenderdat[0]
                )?.elastic_score;
              }

              setresmaxScore(
                parseFloat(
                  (
                    Math.floor(parseFloat(reshighestScoreTender) * 100) / 100
                  ).toFixed(2)
                )
              );
              return updatedGPTData;
            } else {
              setresmaxScore(0);
              return [
                ...prevData,
                { searchId, keysearch, ResultList: response.data.TenderList },
              ];
            }
          });
        }

        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching data:", error);
      }
    }, 500),
    [search, setTenderData, setResultGPTData, setLoading]
  );

  const spanClick = async (ele) => {
    setSelectFromHistory(true);
    const searchId = uuidv4(); // Generate a unique ID for the search
    // if (searchType === "Tender") {
    //   // setTenderGPTData([
    //   //   ...tenderGPTData,
    //   //   { searchId, search, TenderList: [] },
    //   // ]);
    //   setNewSearch(searchId); // Set the current search ID for scrolling
    //   setHistory([...new Set([...history, search])]);
    //   //SET HISTORY TO LOCAL STORAGE
    //   // const storageKey =
    //   //   searchType === "Tender"
    //   //     ? "tenderLocalStorageHistory"
    //   //     : "resultLocalStorageHistory";

    //   // // Fetch the existing data from localStorage
    //   // let storedHistory = JSON.parse(localStorage.getItem(storageKey)) || [];

    //   // // Create a new history object with the current date
    //   // let newHistoryEntry = {
    //   //   date: currentDatenew,
    //   //   history: search,
    //   // };

    //   // // Add the new entry to the stored history array
    //   // storedHistory.push(newHistoryEntry);

    //   // // Save the updated history array back to localStorage
    //   // localStorage.setItem(
    //   //   storageKey,
    //   //   JSON.stringify([...new Set(storedHistory)])
    //   // );
    //   const apiurls =
    //     localStorage.getItem("logDetails") == null
    //       ? "https://tendersearchai.tendertiger.co.in/api/tender/GetTendersListBeforeLoginAI"
    //       : "https://tendersearchai.tendertiger.co.in/api/tender/GetTendersListAI";

    //   debouncedFetchData(searchId, apiurls, "Tender", search);
    // } else {
    //   setResultGPTData([
    //     ...resultGPTData,
    //     { searchId, search, ResultList: [] },
    //   ]);
    //   setNewSearch(searchId); // Set the current search ID for scrolling

    //   setHistory([...new Set([...history, search])]);
    //   //SET HISTORY TO LOCAL STORAGE
    //   // const storageKey =
    //   //   searchType === "Tender"
    //   //     ? "tenderLocalStorageHistory"
    //   //     : "resultLocalStorageHistory";

    //   // // Fetch the existing data from localStorage
    //   // let storedHistory = JSON.parse(localStorage.getItem(storageKey)) || [];

    //   // // Create a new history object with the current date
    //   // let newHistoryEntry = {
    //   //   date: currentDatenew,
    //   //   history: search,
    //   // };

    //   // // Add the new entry to the stored history array
    //   // storedHistory.push(newHistoryEntry);

    //   // // Save the updated history array back to localStorage
    //   // localStorage.setItem(
    //   //   storageKey,
    //   //   JSON.stringify([...new Set(storedHistory)])
    //   // );

    //   debouncedFetchData(
    //     searchId,
    //     "https://tenderresultai.tendertiger.co.in/api/result/GetResultListBeforeLogin",
    //     "Result",
    //     search
    //   );
    // }
    if (searchType === "Tender") {
      setTenderGPTData(ele.searchList);
    } else {
      setResultGPTData(ele.searchList);
    }

    setLastSearchData(ele.searchList?.at(ele.searchList.length - 1).search);
    setSearchData(ele.searchList?.at(ele.searchList.length - 1).search);
    setSearch(ele.searchList?.at(ele.searchList.length - 1).search);
  };
  //FOR SHOW HISTORY WITH DATE
  function parseDate(dateString) {
    const [day, month, year] = dateString.split("/").map(Number);
    return new Date(year, month - 1, day);
  }
  const currentDatenew = new Date().toLocaleDateString("en-GB");
  const currentDate = new Date();
  const today = currentDate.toLocaleDateString("en-GB"); // "dd-mm-yyyy"
  const yesterday = new Date(
    currentDate.setDate(currentDate.getDate() - 1)
  ).toLocaleDateString("en-GB");
  const sevenDaysBefore = new Date(
    currentDate.setDate(currentDate.getDate() - 6)
  ).toLocaleDateString("en-GB");
  const startOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  ).toLocaleDateString("en-GB");
  const startOfYear = new Date(
    currentDate.getFullYear(),
    0,
    1
  ).toLocaleDateString("en-GB");

  // Retrieve and parse the stored history
  const storedHistoryJson = localStorage.getItem(
    searchType === "Tender"
      ? "tenderLocalStorageHistory"
      : "resultLocalStorageHistory"
  );
  const storedHistory = storedHistoryJson
    ? JSON.parse(storedHistoryJson).reverse()
    : [];
  console.log(storedHistory, "storedHistoryZ");

  const categorizedHistory = {
    today: [],
    yesterday: [],
    sevenDaysBefore: [],
    thisMonth: [],
    thisYear: [],
  };

  const todayDate = parseDate(today);
  const yesterdayDate = parseDate(yesterday);
  const sevenDaysBeforeDate = parseDate(sevenDaysBefore);
  const startOfMonthDate = parseDate(startOfMonth);
  const startOfYearDate = parseDate(startOfYear);
  // Categorize the history based on the date
  storedHistory.forEach((entry) => {
    const entryDate = parseDate(entry.date);

    if (entryDate.getTime() === todayDate.getTime()) {
      categorizedHistory.today = categorizedHistory.today.concat(entry);
    } else if (entryDate.getTime() === yesterdayDate.getTime()) {
      categorizedHistory.yesterday = categorizedHistory.yesterday.concat(entry);
    } else if (entryDate >= sevenDaysBeforeDate && entryDate < todayDate) {
      categorizedHistory.sevenDaysBefore =
        categorizedHistory.sevenDaysBefore.concat(entry);
    } else if (entryDate >= startOfMonthDate) {
      categorizedHistory.thisMonth = categorizedHistory.thisMonth.concat(entry);
    } else if (entryDate >= startOfYearDate && entryDate < startOfMonthDate) {
      categorizedHistory.thisYear = categorizedHistory.thisYear.concat(entry);
    }
  });
  const [expandedSections, setExpandedSections] = useState({
    today: true,
    yesterday: false,
    sevenDaysBefore: false,
    thisMonth: false,
    thisYear: false,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <>
      {/* <Card className="sidebar">
        <Card.Header>
          <Card.Title>History</Card.Title>
        </Card.Header>
        <Card.Body> 
          <Card.Text>History</Card.Text>
        </Card.Body>
      </Card> */}

      <div className={`sidebar ${showSideBar ? "expanded" : "collapsed"}`}>
        <div className="sidebar-header">
          {showSideBar ? <h4 className="history-title">History</h4> : ""}
          <div className="sidebar-btn">
            <IconButton
              aria-label="Toggle Sidebar"
              onClick={() => setShowShowSideBar(!showSideBar)}
              className="menu-icon"
              style={{
                transform: showSideBar ? "rotate(180deg)" : "rotate(360deg)",
              }}
            >
              <MenuOpenIcon style={{ color: "#404040" }} />
            </IconButton>
          </div>
        </div>
        {showSideBar && (
          <div className="sidebar-content">
            {/* {searchType === "Tender" ?
              tenderGPTData.map(ele => { return <span onClick={() => spanClick(ele.search)}>{ele.search}</span> }) */}
            {/* : */}
            {/* //JSON.parse(Cookies.get("tenderGPTDataHistory") || "[]") */}

            {/* {history.length > 0 &&
              history?.map((ele, index) => {
                return (
                  <span
                    onClick={() => spanClick(ele)}
                    disabled={loading}
                    key={index}
                  >
                    {ele}
                  </span>
                );
              })} */}

            <div className="history-container">
              <div className="section">
                {categorizedHistory.today.length > 0 ? (
                  <>
                    <h4
                      onClick={() => toggleSection("today")}
                      className="section-header"
                    >
                      Today
                      {/* <span className="arrow">{expandedSections.today ? '▲' : '▼'}</span>\ */}
                      {expandedSections.today ? <ExpandLess /> : <ExpandMore />}
                    </h4>
                    {expandedSections.today && (
                      <div className="history-items">
                        {[...new Set(categorizedHistory.today)].map(
                          (ele, index) => (
                            <div className="history-item-container">
                              <span
                                onClick={() => spanClick(ele)}
                                disabled={loading}
                                key={`today-${index}`}
                                className="history-item"
                              >
                                {ele.history}
                              </span>
                              <div onClick={() => toggleHeart(ele.thredId)} style={{ cursor: 'pointer' }}>
                                <i className={`fa${ele.isfav ? 's' : 'r'} fa-heart`}></i>
                              </div>
                              {/* <div> <i className="fa fa fa-heart"></i> </div> */}
                            </div>
                          )
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <div className="history-items">No Search History Today</div>
                )}
              </div>

              {categorizedHistory.yesterday.length > 0 && (
                <div className="section">
                  <h4
                    onClick={() => toggleSection("yesterday")}
                    className="section-header"
                  >
                    Yesterday
                    {/* <span className="arrow">{expandedSections.yesterday ? '▲' : '▼'}</span> */}
                    {expandedSections.yesterday ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </h4>
                  {expandedSections.yesterday && (
                    <div className="history-items">
                      {[...new Set(categorizedHistory.yesterday)]?.map(
                        (ele, index) => (
                          <div className="history-item-container">
                            <span
                              onClick={() => spanClick(ele)}
                              disabled={loading}
                              key={`yesterday-${index}`}
                              className="history-item"
                            >
                              {ele.history}
                            </span>
                            <div onClick={() => toggleHeart(ele.thredId)} style={{ cursor: 'pointer' }}>
                              <i className={`fa${ele.isfav ? 's' : 'r'} fa-heart`}></i>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              )}

              {categorizedHistory.sevenDaysBefore.length > 0 && (
                <div className="section">
                  <h4
                    onClick={() => toggleSection("sevenDaysBefore")}
                    className="section-header"
                  >
                    Last 7 Days
                    {/* <span className="arrow">{expandedSections.sevenDaysBefore ? '▲' : '▼'}</span> */}
                    {expandedSections.sevenDaysBefore ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </h4>
                  {expandedSections.sevenDaysBefore &&
                    categorizedHistory.sevenDaysBefore.length > 0 && (
                      <div className="history-items">
                        {[...new Set(categorizedHistory.sevenDaysBefore)]?.map(
                          (ele, index) => (
                            <div className="history-item-container">
                              <span
                                onClick={() => spanClick(ele)}
                                disabled={loading}
                                key={`sevenDays-${index}`}
                                className="history-item"
                              >
                                {ele.history}
                              </span>
                              <div onClick={() => toggleHeart(ele.thredId)} style={{ cursor: 'pointer' }}>
                                <i className={`fa${ele.isfav ? 's' : 'r'} fa-heart`}></i>
                              </div>
                            </div>

                          )
                        )}
                      </div>
                    )}
                </div>
              )}

              {categorizedHistory.thisMonth.length > 0 && (
                <div className="section">
                  <h4
                    onClick={() => toggleSection("thisMonth")}
                    className="section-header"
                  >
                    This Month
                    {/* <span className="arrow">{expandedSections.thisMonth ? '▲' : '▼'}</span> */}
                    {expandedSections.thisMonth ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </h4>
                  {expandedSections.thisMonth && (
                    <div className="history-items">
                      {[...new Set(categorizedHistory.thisMonth)].map(
                        (ele, index) => (
                          <div className="history-item-container">
                            <span
                              onClick={() => spanClick(ele)}
                              disabled={loading}
                              key={`thisMonth-${index}`}
                              className="history-item"
                            >
                              {ele.history}
                            </span>
                            <div onClick={() => toggleHeart(ele.thredId)} style={{ cursor: 'pointer' }}>
                              <i className={`fa${ele.isfav ? 's' : 'r'} fa-heart`}></i>
                            </div>
                          </div>

                        )
                      )}
                    </div>
                  )}
                </div>
              )}

              {categorizedHistory.thisYear.length > 0 && (
                <div className="section">
                  <h4
                    onClick={() => toggleSection("thisYear")}
                    className="section-header"
                  >
                    This Year
                    {/* <span className="arrow">{expandedSections.thisYear ? '▲' : '▼'}</span> */}
                    {expandedSections.thisYear ? (
                      <ExpandLess />
                    ) : (
                      <ExpandMore />
                    )}
                  </h4>
                  {expandedSections.thisYear && (
                    <div className="history-items">
                      {[...new Set(categorizedHistory.thisYear)]?.map(
                        (ele, index) => (
                          <div className="history-item-container">
                            <span
                              onClick={() => spanClick(ele)}
                              disabled={loading}
                              key={`thisYear-${index}`}
                              className="history-item"
                            >
                              {ele.history}
                            </span>
                            <div onClick={() => toggleHeart(ele.thredId)} style={{ cursor: 'pointer' }}>
                              <i className={`fa${ele.isfav ? 's' : 'r'} fa-heart`}></i>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="social-media"
              style={{
                

                
              }}
            >
              {/* Your existing sidebar content */}
              <div>{/* ...Your history, links etc... */}</div>
              {/* Social Icons at bottom */}
              <div
                style={{
                  padding: 16,
                  display: "flex",
                  gap: 12,
                  justifyContent: "center",
                }}
              >
                <a
                  href="https://www.facebook.com/profile.php?id=61576372365357"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebook size={18} color="#1877f3" />
                </a>
                <a
                  href="https://www.linkedin.com/company/107611997/admin/dashboard/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin size={18} color="#0077b5" />
                </a>
                <a
                  href="https://www.instagram.com/tendergptofficial/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram size={18} color="#e4405f" />
                </a>
                <a
                  href="https://youtube.com/@tendergptofficial?si=ONR7PN2DB5nDu8Tl"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube size={18} color="#ff0000" />
                </a>
              </div>
            </div>
            <button
              className="cleare-history-button"
              onClick={() => {
                setHistory([]);
                localStorage.removeItem("tenderLocalStorageHistory")
                localStorage.removeItem("resultLocalStorageHistory")
              }}
            >
              <i className="fa fa-trash"></i> Clear History
            </button>
          </div>
        )}
      </div>
    </>
  );
}

// render(<SidebarComponent />);
export default Sidebar;
